(() => {
  if (window.CommunitySelect) return;

  const close = (root) => {
    root.classList.remove('is-open');
    root.querySelector('[data-community-select-trigger]').setAttribute('aria-expanded', 'false');
    root.querySelector('[data-community-select-list]').hidden = true;
  };

  const closeAll = (except) => {
    document.querySelectorAll('[data-community-select].is-open').forEach((root) => {
      if (root !== except) close(root);
    });
  };

  const init = (root) => {
    if (!root || root.dataset.communitySelectReady === 'true') return;
    const nativeSelect = root.querySelector('[data-community-select-native]');
    const trigger = root.querySelector('[data-community-select-trigger]');
    const list = root.querySelector('[data-community-select-list]');
    const options = Array.from(root.querySelectorAll('[data-community-select-option]'));
    if (!nativeSelect || !trigger || !list || !options.length) return;
    root.dataset.communitySelectReady = 'true';

    const sync = () => {
      const selected = nativeSelect.options[nativeSelect.selectedIndex];
      const triggerLabel = trigger.querySelector('[data-community-select-trigger-label]') || trigger;
      triggerLabel.textContent = selected ? selected.textContent : '';
      options.forEach((option) => {
        const isSelected = Number(option.dataset.index) === nativeSelect.selectedIndex;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-selected', String(isSelected));
      });
    };
    const open = () => {
      closeAll(root);
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      list.hidden = false;
      const selected = options.find(option => Number(option.dataset.index) === nativeSelect.selectedIndex);
      if (selected) {
        const itemBounds = selected.getBoundingClientRect();
        const listBounds = list.getBoundingClientRect();
        list.scrollTop += itemBounds.top - listBounds.top - list.clientTop - (list.clientHeight - itemBounds.height) / 2;
      } else list.scrollTop = 0;
    };
    const choose = (option) => {
      nativeSelect.selectedIndex = Number(option.dataset.index);
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      close(root);
      trigger.focus();
    };

    trigger.addEventListener('click', () => { if (list.hidden) open(); else close(root); });
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowDown' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        open();
        (options.find(option => Number(option.dataset.index) === nativeSelect.selectedIndex) || options[0]).focus({ preventScroll: true });
      }
    });
    options.forEach((option, index) => {
      option.addEventListener('click', () => choose(option));
      option.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') { event.preventDefault(); (options[index + 1] || options[0]).focus(); }
        else if (event.key === 'ArrowUp') { event.preventDefault(); (options[index - 1] || options[options.length - 1]).focus(); }
        else if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(option); }
        else if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(root); trigger.focus(); }
      });
    });
    nativeSelect.addEventListener('change', sync);
    nativeSelect._communitySelectSync = sync;
    sync();
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-community-select]').forEach(init);
  const refresh = (nativeSelect) => {
    const oldRoot = nativeSelect.closest('[data-community-select]');
    if (!oldRoot) return;
    const root = oldRoot.cloneNode(true);
    delete root.dataset.communitySelectReady;
    const select = root.querySelector('[data-community-select-native]');
    select.selectedIndex = nativeSelect.selectedIndex;
    const trigger = root.querySelector('[data-community-select-trigger]');
    (trigger.querySelector('[data-community-select-trigger-label]') || trigger).textContent = select.options[select.selectedIndex]?.textContent || '';
    trigger.disabled = select.disabled || !select.options.length;
    const list = root.querySelector('[data-community-select-list]');
    list.replaceChildren(...Array.from(select.options, (option, index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'community-select__option';
      button.textContent = option.textContent; button.dataset.communitySelectOption = '';
      button.dataset.index = index; button.tabIndex = -1; button.setAttribute('role', 'option');
      return button;
    }));
    oldRoot.replaceWith(root);
    close(root);
    init(root);
  };
  document.addEventListener('click', (event) => { if (!event.target.closest('[data-community-select]')) closeAll(); });
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  window.CommunitySelect = { init, initAll, refresh, sync: (nativeSelect) => { if (nativeSelect && nativeSelect._communitySelectSync) nativeSelect._communitySelectSync(); }, closeAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
})();
